import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: -1;\n    background-color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { transparentize } from 'polished';
import focusTrap from 'focus-trap-js';
import { noop } from '../helpers';
var StyledModal = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.zIndex.modal;
});
var Overlay = styled.div(_templateObject2(), function (_ref2) {
  var theme = _ref2.theme;
  return transparentize(0.6, theme.palette.common.black);
});
export function Modal(_a) {
  var children = _a.children,
      opened = _a.opened,
      _a$keepMounted = _a.keepMounted,
      keepMounted = _a$keepMounted === void 0 ? false : _a$keepMounted,
      _a$disablePortal = _a.disablePortal,
      disablePortal = _a$disablePortal === void 0 ? false : _a$disablePortal,
      _a$disableOverlay = _a.disableOverlay,
      disableOverlay = _a$disableOverlay === void 0 ? false : _a$disableOverlay,
      _a$disableScrollLock = _a.disableScrollLock,
      disableScrollLock = _a$disableScrollLock === void 0 ? false : _a$disableScrollLock,
      _a$disableRestoreFocu = _a.disableRestoreFocus,
      disableRestoreFocus = _a$disableRestoreFocu === void 0 ? false : _a$disableRestoreFocu,
      _a$onOverlayClick = _a.onOverlayClick,
      onOverlayClick = _a$onOverlayClick === void 0 ? noop : _a$onOverlayClick,
      _a$disableOverlayClic = _a.disableOverlayClick,
      disableOverlayClick = _a$disableOverlayClic === void 0 ? false : _a$disableOverlayClic,
      _a$onEscKeyDown = _a.onEscKeyDown,
      onEscKeyDown = _a$onEscKeyDown === void 0 ? noop : _a$onEscKeyDown,
      _a$disableEscKeyDown = _a.disableEscKeyDown,
      disableEscKeyDown = _a$disableEscKeyDown === void 0 ? false : _a$disableEscKeyDown,
      _a$onClose = _a.onClose,
      onClose = _a$onClose === void 0 ? noop : _a$onClose,
      props = __rest(_a, ["children", "opened", "keepMounted", "disablePortal", "disableOverlay", "disableScrollLock", "disableRestoreFocus", "onOverlayClick", "disableOverlayClick", "onEscKeyDown", "disableEscKeyDown", "onClose"]);

  var focusedElement = useRef();
  var refContainer = useRef(null);
  var handleOverlayClick = useCallback(function (event) {
    if (disableOverlayClick) {
      return;
    }

    onOverlayClick(event);
    onClose(event, 'overlay');
  }, [onOverlayClick, disableOverlayClick, onClose]);
  var handleEscKeyDown = useCallback(function (event) {
    if (event.key !== 'Escape' || disableEscKeyDown) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    onEscKeyDown(event);
    onClose(event, 'escapeKey');
  }, [onEscKeyDown, disableEscKeyDown, onClose]);
  useEffect(function () {
    document.addEventListener('keydown', handleEscKeyDown);
    return function () {
      document.removeEventListener('keydown', handleEscKeyDown);
    };
  }, []);
  useEffect(function () {
    if (disableScrollLock) {
      return;
    }

    document.body.style.overflowY = opened ? 'hidden' : '';
  }, [opened, disableScrollLock]);
  useEffect(function () {
    if (disableRestoreFocus) {
      return;
    }

    if (opened && document.activeElement) {
      focusedElement.current = document.activeElement;
    } else if (focusedElement.current) {
      focusedElement.current.focus();
    }
  }, [opened, disableRestoreFocus]);
  useEffect(function () {
    function handleKeyEvent(event) {
      if (refContainer.current) {
        return focusTrap(event, refContainer.current);
      }
    }

    document.addEventListener('keydown', handleKeyEvent);
    return function () {
      document.removeEventListener('keydown', handleKeyEvent);
    };
  }, [refContainer]);
  var childrenToRender = !keepMounted && !opened ? null : React.createElement(StyledModal, Object.assign({}, props, {
    ref: refContainer,
    hidden: !opened
  }), !disableOverlay && React.createElement(Overlay, {
    onClick: handleOverlayClick
  }), children);
  return disablePortal ? childrenToRender : ReactDOM.createPortal(childrenToRender, document.body);
}